import { SvgIcon, type SvgIconProps } from '@mui/material';

export const BTC_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="0 0 4091.27 4091.73"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <title>BTC</title>
    <path
      fill="#F7931A"
      fillRule="nonzero"
      d="M4030.06 2540.77c-273.24,1096.01 -1383.32,1763.02 -2479.46,1489.71 -1095.68,-273.24 -1762.69,-1383.39 -1489.33,-2479.31 273.12,-1096.13 1383.2,-1763.19 2479,-1489.95 1096.06,273.24 1763.03,1383.51 1489.76,2479.57l0.02 -0.02z"
    />
    <path
      fill="white"
      fillRule="nonzero"
      d="M2947.77 1754.38c40.72,-272.26 -166.56,-418.61 -450,-516.24l91.95 -368.8 -224.5 -55.94 -89.51 359.09c-59.02,-14.72 -119.63,-28.59 -179.87,-42.34l90.16 -361.46 -224.36 -55.94 -92 368.68c-48.84,-11.12 -96.81,-22.11 -143.35,-33.69l0.26 -1.16 -309.59 -77.31 -59.72 239.78c0,0 166.56,38.18 163.05,40.53 90.91,22.69 107.35,82.87 104.62,130.57l-104.74 420.15c6.26,1.59 14.38,3.89 23.34,7.49 -7.49,-1.86 -15.46,-3.89 -23.73,-5.87l-146.81 588.57c-11.11,27.62 -39.31,69.07 -102.87,53.33 2.25,3.26 -163.17,-40.72 -163.17,-40.72l-111.46 256.98 292.15 72.83c54.35,13.63 107.61,27.89 160.06,41.3l-92.9 373.03 224.24 55.94 92 -369.07c61.26,16.63 120.71,31.97 178.91,46.43l-91.69 367.33 224.51 55.94 92.89 -372.33c382.82,72.45 670.67,43.24 791.83,-303.02 97.63,-278.78 -4.86,-439.58 -206.26,-544.44 146.69,-33.83 257.18,-130.31 286.64,-329.61l-0.07 -0.05zm-512.93 719.26c-69.38,278.78 -538.76,128.08 -690.94,90.29l123.28 -494.2c152.17,37.99 640.17,113.17 567.67,403.91zm69.43 -723.3c-63.29,253.58 -453.96,124.75 -580.69,93.16l111.77 -448.21c126.73,31.59 534.85,90.55 468.94,355.05l-0.02 0z"
    />
  </svg>
);

export const ETH_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>ETH</title>
    <circle cx="11.9972" cy="12" r="12" fill="#F3F4F7" />
    <path d="M11.5267 3L11.4059 3.41024V15.3133L11.5267 15.4338L17.0519 12.1678L11.5267 3Z" fill="#343434" />
    <path d="M11.5254 3L6.00012 12.1678L11.5254 15.4338V9.65637V3Z" fill="#8C8C8C" />
    <path d="M11.5267 16.4782L11.4587 16.5612V20.8013L11.5267 21L17.0553 13.214L11.5267 16.4782Z" fill="#3C3C3B" />
    <path d="M11.5254 21V16.4782L6.00012 13.214L11.5254 21Z" fill="#8C8C8C" />
    <path d="M11.5246 15.44L17.0498 12.174L11.5246 9.66257V15.44Z" fill="#141414" />
    <path d="M6.00012 12.174L11.5254 15.44V9.66257L6.00012 12.174Z" fill="#393939" />
  </svg>
);

export const USDT_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 339.43 295.27">
    <title>USDT</title>
    <path
      d="M62.15,1.45l-61.89,130a2.52,2.52,0,0,0,.54,2.94L167.95,294.56a2.55,2.55,0,0,0,3.53,0L338.63,134.4a2.52,2.52,0,0,0,.54-2.94l-61.89-130A2.5,2.5,0,0,0,275,0H64.45a2.5,2.5,0,0,0-2.3,1.45h0Z"
      fill="#50af95"
      fillRule="evenodd"
    />
    <path
      d="M191.19,144.8v0c-1.2.09-7.4,0.46-21.23,0.46-11,0-18.81-.33-21.55-0.46v0c-42.51-1.87-74.24-9.27-74.24-18.13s31.73-16.25,74.24-18.15v28.91c2.78,0.2,10.74.67,21.74,0.67,13.2,0,19.81-.55,21-0.66v-28.9c42.42,1.89,74.08,9.29,74.08,18.13s-31.65,16.24-74.08,18.12h0Zm0-39.25V79.68h59.2V40.23H89.21V79.68H148.4v25.86c-48.11,2.21-84.29,11.74-84.29,23.16s36.18,20.94,84.29,23.16v82.9h42.78V151.83c48-2.21,84.12-11.73,84.12-23.14s-36.09-20.93-84.12-23.15h0Zm0,0h0Z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);

export const AUSD_SVG = (
  <svg width="1em" height="1em" viewBox="0 0 64 64" fill="none">
    <title>AUSD</title>
    <path
      d="M32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0Z"
      fill="#9A9350"
    />
    <path
      d="M31.4357 8V23.8739C31.4357 24.5405 30.6429 24.8649 30.1744 24.3964L22.6969 17.0991L25.832 8.95495C26.0483 8.37838 26.6068 8 27.2194 8H31.4357Z"
      fill="white"
    />
    <path
      d="M31.4357 29.6216V38.5405C31.4357 39.1351 30.733 39.4234 30.3006 39.027L18.715 28.1081L22.1204 19.2792L30.5708 27.5495C31.1294 28.09 31.4357 28.8288 31.4357 29.6216Z"
      fill="white"
    />
    <path
      d="M31.4355 44V48H13.4715C12.4445 48 11.7238 46.955 12.1022 46L18.1202 30.3243L30.6067 42.1081C31.1472 42.5946 31.4355 43.2793 31.4355 44Z"
      fill="white"
    />
    <path
      d="M33.3634 8V23.8739C33.3634 24.5405 34.1562 24.8649 34.6247 24.3964L42.0841 17.0991L38.967 8.95495C38.7328 8.37838 38.1922 8 37.5796 8H33.3634Z"
      fill="white"
    />
    <path
      d="M33.3635 29.6216V38.5405C33.3635 39.1351 34.0662 39.4234 34.4986 39.027L46.0842 28.1081L42.6788 19.2792L34.2283 27.5495C33.6698 28.09 33.3455 28.8288 33.3455 29.6216H33.3635Z"
      fill="white"
    />
    <path
      d="M33.3634 44V48H51.3094C52.3544 48 53.0751 46.955 52.6968 46L46.6607 30.3243L34.1742 42.1081C33.6517 42.5946 33.3634 43.2793 33.3634 44Z"
      fill="white"
    />
  </svg>
);

export const MATIC_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>MATIC</title>
    <g clipPath="url(#clip0_56_2175)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#8247E5"
      />
      <path
        d="M15.9717 9.43253C15.6839 9.26509 15.3097 9.26509 14.9931 9.43253L12.7481 10.7163L11.2227 11.5535L8.97764 12.8372C8.68981 13.0046 8.31565 13.0046 7.99903 12.8372L6.21453 11.8325C5.92671 11.6651 5.72524 11.3581 5.72524 11.0232V9.04183C5.72524 8.70695 5.89793 8.39997 6.21453 8.23253L7.97025 7.25577C8.25806 7.08834 8.63224 7.08834 8.94886 7.25577L10.7046 8.23253C10.9924 8.39997 11.1939 8.70695 11.1939 9.04183V10.3255L12.7193 9.46042V8.1767C12.7193 7.84183 12.5466 7.53484 12.23 7.36741L8.97764 5.52555C8.68981 5.35811 8.31565 5.35811 7.99903 5.52555L4.68907 7.36741C4.37246 7.53484 4.19977 7.84183 4.19977 8.1767V11.8883C4.19977 12.2232 4.37246 12.5302 4.68907 12.6976L7.99903 14.5395C8.28687 14.707 8.66103 14.707 8.97764 14.5395L11.2227 13.2837L12.7481 12.4186L14.9931 11.1628C15.2809 10.9953 15.6551 10.9953 15.9717 11.1628L17.7274 12.1395C18.0153 12.307 18.2168 12.6139 18.2168 12.9488V14.9302C18.2168 15.2651 18.044 15.5721 17.7274 15.7395L15.9717 16.7442C15.6839 16.9116 15.3097 16.9116 14.9931 16.7442L13.2374 15.7674C12.9496 15.6 12.7481 15.293 12.7481 14.9581V13.6744L11.2227 14.5395V15.8232C11.2227 16.1581 11.3953 16.4651 11.712 16.6325L15.0219 18.4744C15.3097 18.6418 15.6839 18.6418 16.0005 18.4744L19.3105 16.6325C19.5983 16.4651 19.7998 16.1581 19.7998 15.8232V12.1116C19.7998 11.7767 19.6271 11.4697 19.3105 11.3023L15.9717 9.43253Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_56_2175">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BNB_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>BNB</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0Z"
      fill="#F0B90B"
    />
    <path
      d="M6.59519 12L6.60385 15.1731L9.3 16.7596V18.6173L5.02596 16.1106V11.0721L6.59519 12ZM6.59519 8.82692V10.676L5.025 9.74712V7.89808L6.59519 6.96923L8.17308 7.89808L6.59519 8.82692ZM10.426 7.89808L11.9962 6.96923L13.574 7.89808L11.9962 8.82692L10.426 7.89808Z"
      fill="white"
    />
    <path
      d="M7.7298 14.5154V12.6577L9.3 13.5865V15.4356L7.7298 14.5154ZM10.426 17.425L11.9962 18.3538L13.574 17.425V19.274L11.9962 20.2029L10.426 19.274V17.425ZM15.826 7.89808L17.3962 6.96923L18.974 7.89808V9.74712L17.3962 10.676V8.82692L15.826 7.89808ZM17.3962 15.1731L17.4048 12L18.975 11.0712V16.1096L14.701 18.6163V16.7587L17.3962 15.1731Z"
      fill="white"
    />
    <path d="M16.2702 14.5154L14.7 15.4356V13.5865L16.2702 12.6577V14.5154Z" fill="white" />
    <path
      d="M16.2702 9.48462L16.2788 11.3423L13.575 12.9288V16.1096L12.0048 17.0298L10.4346 16.1096V12.9288L7.73077 11.3423V9.48462L9.30769 8.55577L11.9952 10.15L14.699 8.55577L16.2769 9.48462H16.2702ZM7.7298 6.3125L11.9962 3.79712L16.2702 6.3125L14.7 7.24135L11.9962 5.64712L9.3 7.24135L7.7298 6.3125Z"
      fill="white"
    />
  </svg>
);

export const SOL_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>SOL</title>
    <path
      d="M11.9902 0H12.0098C18.6307 0 24 5.2282 24 11.675V12.325C24 18.7718 18.6307 24 12.0098 24H11.9902C5.36933 24 0 18.7718 0 12.325V11.675C0 5.2282 5.36933 0 11.9902 0Z"
      fill="#232323"
    />
    <path
      d="M17.0064 8.99998C16.968 9.04318 16.92 9.07678 16.8672 9.09598C16.8144 9.11998 16.7568 9.12958 16.6992 9.12958H5.82724C5.44324 9.12958 5.24644 8.64958 5.51524 8.36158L7.30084 6.46558C7.33924 6.42238 7.38724 6.38878 7.44484 6.36478C7.49764 6.34078 7.55524 6.33118 7.61284 6.33118H18.528C18.9168 6.33118 19.1088 6.81598 18.8352 7.10398L17.0064 8.99998ZM17.0064 17.4768C16.9248 17.5584 16.8144 17.6064 16.6992 17.6064H5.82724C5.44324 17.6064 5.24644 17.136 5.51524 16.8576L7.30084 15.0048C7.33924 14.9616 7.39204 14.928 7.44484 14.9088C7.49764 14.8848 7.55524 14.8752 7.61284 14.8752H18.528C18.9168 14.8752 19.1088 15.3504 18.8352 15.6288L17.0064 17.4768ZM17.0064 10.7328C16.9248 10.6512 16.8144 10.6032 16.6992 10.6032H5.82724C5.44324 10.6032 5.24644 11.0736 5.51524 11.352L7.30084 13.2048C7.33924 13.248 7.39204 13.2816 7.44484 13.3008C7.49764 13.3248 7.55524 13.3344 7.61284 13.3344H18.528C18.9168 13.3344 19.1088 12.8592 18.8352 12.5808L17.0064 10.7328Z"
      fill="url(#sol_gradient)"
    />
    <defs>
      <linearGradient id="sol_gradient" x1="6.22103" y1="17.7471" x2="18.0979" y2="6.18399" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CF41E8" />
        <stop offset="1" stopColor="#10F2B0" />
      </linearGradient>
    </defs>
  </svg>
);

export const AVAX_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>AVAX</title>
    <rect width="24" height="24" rx="12" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37258 0 0 5.37259 0 12C0 18.6274 5.37258 24 12 24ZM8.37413 17.4365H5.55905C4.89161 17.4365 4.55787 17.4365 4.35801 17.3073C4.14201 17.1676 4.00572 16.9332 3.99129 16.6765C3.9779 16.439 4.1432 16.1494 4.47378 15.5703L10.6374 4.77236C10.9728 4.18464 11.1406 3.89078 11.354 3.78139C11.5846 3.66322 11.858 3.66301 12.0887 3.78087C12.3023 3.88993 12.4705 4.18357 12.8068 4.77077L14.2283 7.25267C14.4728 7.67963 14.5951 7.89322 14.6489 8.11845C14.7075 8.36368 14.7076 8.61915 14.6493 8.86438C14.5957 9.08969 14.4736 9.30336 14.2294 9.73057L10.5437 16.1783C10.2959 16.6117 10.172 16.8285 10.0023 16.9905C9.81751 17.1668 9.59346 17.2968 9.34856 17.3697C9.12355 17.4365 8.87376 17.4365 8.37413 17.4365ZM18.4175 17.4365H15.1537C14.4803 17.4365 14.1435 17.4365 13.943 17.3062C13.7264 17.1653 13.5905 16.9291 13.5777 16.6712C13.5658 16.4326 13.7353 16.1418 14.0743 15.5603L15.7034 12.7651C16.0381 12.191 16.2055 11.9039 16.4174 11.7964C16.6463 11.6802 16.9171 11.68 17.1463 11.7958C17.3583 11.903 17.526 12.1899 17.8615 12.7635L19.4961 15.5587C19.8364 16.1406 20.0065 16.4315 19.9949 16.6704C19.9823 16.9285 19.8465 17.1649 19.6298 17.306C19.4293 17.4365 19.092 17.4365 18.4175 17.4365Z"
      fill="#E84142"
    />
  </svg>
);

export const TRX_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>TRX</title>
    <g clipPath="url(#trx_clip)">
      <path
        d="M12 24C18.6275 24 24 18.6275 24 12C24 5.37258 18.6275 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6275 5.37258 24 12 24Z"
        fill="#EB0029"
      />
      <path
        d="M16.449 7.43481L5.625 5.44281L11.3212 19.7768L19.2585 10.1063L16.449 7.43481ZM16.275 8.31233L17.931 9.88658L13.4025 10.7063L16.275 8.31233ZM12.4185 10.5421L7.6455 6.58356L15.447 8.01907L12.4185 10.5421ZM12.0787 11.2426L11.3003 17.6776L7.104 7.11531L12.0787 11.2426ZM12.7988 11.5838L17.814 10.6763L12.0615 17.6836L12.7988 11.5838Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="trx_clip">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ZEC_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>ZEC</title>
    <path
      fill="#ecb244"
      d="M12 24c6.627 0 12-5.373 12-12C24 5.373 18.627 0 12 0C5.373 0 0 5.373 0 12c0 6.627 5.373 12 12 12Z"
    />
    <path
      fill="#ffffff"
      d="M11.322 14.8845h4.72275v2.5125h-2.90625c0.048 0.7185 0.07275 1.38525 0.12075 2.103h-2.4457v-2.0775h-2.907c0-0.81975-0.09675-1.64025 0.04875-2.40975 0.07275-0.41025 0.5085-0.7695 0.7747-1.128 0.921225-1.151175 1.849725-2.296425 2.7855-3.43575 0.36375-0.4365 0.72675-0.84675 1.1385-1.3335h-4.53v-2.5125h2.6895V4.5h2.349v2.05125h2.931c0 0.846-0.09675 1.6665-0.04875 2.436-0.07275 0.41025-0.5085 0.7695-0.79875 1.128-0.92115 1.151175-1.84965 2.296425-2.7855 3.43575-0.3654 0.456375-0.74505 0.90105-1.1385 1.3335Z"
    />
  </svg>
);

export const DEFAULT_SVG = (
  <svg width="1em" height="1em" viewBox="-5 -5 34 34" xmlns="http://www.w3.org/2000/svg" fill="none">
    <circle cx="12" cy="12" r="17" fill="#836EF9" />
    <path
      d="M11.9999 0C8.53463 0 0 8.5344 0 11.9999C0 15.4655 8.53463 24 11.9999 24C15.4652 24 24 15.4653 24 11.9999C24 8.53455 15.4654 0 11.9999 0ZM10.13 18.8619C8.66865 18.4637 4.73986 11.5913 5.13812 10.13C5.53639 8.66858 12.4087 4.73984 13.87 5.1381C15.3313 5.5363 19.2602 12.4087 18.8619 13.8701C18.4636 15.3314 11.5913 19.2602 10.13 18.8619Z"
      fill="white"
    />
  </svg>
);

export const PERPL_SVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="9" fill="white" />
    <g clip-path="url(#clip0_11974_2549)">
      <path d="M7.09314 4H5.25V14H7.09314V4Z" fill="#6F5CFF" />
      <path d="M10.8973 8.98041H9.0542V14H10.8973V8.98041Z" fill="#6F5CFF" />
      <path d="M12.7401 4H10.897V8.98039H12.7401V4Z" fill="#6F5CFF" />
    </g>
    <defs>
      <clipPath id="clip0_11974_2549">
        <rect width="7.5" height="10" fill="white" transform="translate(5.25 4)" />
      </clipPath>
    </defs>
  </svg>
);

export const HYPE_SVG = (
  <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M144 71.6991C144 119.306 114.866 134.582 99.5156 120.98C86.8804 109.889 83.1211 86.4521 64.116 84.0456C39.9942 81.0113 37.9057 113.133 22.0334 113.133C3.5504 113.133 0 86.2428 0 72.4315C0 58.3063 3.96809 39.0542 19.736 39.0542C38.1146 39.0542 39.1588 66.5722 62.132 65.1073C85.0007 63.5379 85.4184 34.8689 100.247 22.6271C113.195 12.0593 144 23.4641 144 71.6991Z"
      fill="#97FCE4"
    />
  </svg>
);

export const LIT_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 64 64" fill="none">
    <title>LIT</title>
    <g filter="url(#lit_inner_shadow)">
      <path
        d="M64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32Z"
        fill="url(#lit_face_gradient)"
      />
    </g>
    <path
      d="M30.7619 43.084L22.625 50.7499V21.3309L30.7619 13.25V43.084ZM41.3749 43.1024L33.2381 50.7499V39.2765L41.3749 31.2187V43.1024Z"
      fill="white"
    />
    <path
      d="M62.6666 31.9997C62.6666 15.0629 48.9366 1.33301 31.9999 1.33301C15.0632 1.33301 1.33325 15.0629 1.33325 31.9997C1.33325 48.9364 15.0632 62.6663 31.9999 62.6663C48.9366 62.6663 62.6666 48.9364 62.6666 31.9997Z"
      stroke="url(#lit_ring_gradient)"
      strokeWidth="2.66667"
    />
    <defs>
      <filter
        id="lit_inner_shadow"
        x="0"
        y="0"
        width="64"
        height="64"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="10.6667" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0 0.0470588 0 0 0 1 0" />
        <feBlend mode="normal" in2="shape" result="lit_effect_inner_shadow" />
      </filter>
      <linearGradient id="lit_face_gradient" x1="64" y1="0" x2="0" y2="64" gradientUnits="userSpaceOnUse">
        <stop offset="0.3" stopColor="#121218" />
        <stop offset="0.495192" stopColor="#2F2F3E" />
        <stop offset="0.7" stopColor="#121218" />
      </linearGradient>
      <linearGradient id="lit_ring_gradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B3B3BD" />
        <stop offset="0.3" stopColor="#2B2B30" />
        <stop offset="0.504808" stopColor="#121218" />
        <stop offset="0.7" stopColor="#2B2B30" />
        <stop offset="1" stopColor="#B3B3BD" />
      </linearGradient>
    </defs>
  </svg>
);

export const PUMP_SVG = (
  <svg width="1em" height="1em" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>PUMP</title>
    <circle cx="100" cy="100" r="100" fill="#1D3934" />
    <g transform="translate(100 100) scale(0.7) translate(-100 -100)">
      <path
        d="M21.8855 184.247C-2.01603 162.076 -3.41853 124.726 18.753 100.824L94.7609 18.8855C116.932 -5.01605 154.282 -6.41855 178.184 15.7529C202.085 37.9244 203.488 75.274 181.316 99.1756L105.308 181.115C83.1367 205.016 45.7871 206.419 21.8855 184.247Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.753 100.824C-3.41853 124.726 -2.01603 162.076 21.8855 184.247C45.7871 206.419 83.1367 205.016 105.308 181.115L145.81 137.452L59.2549 57.1621L18.753 100.824ZM40.6908 123.847C41.4209 122.946 41.2828 121.625 40.3824 120.895C39.482 120.165 38.1603 120.303 37.4302 121.203L34.9463 124.267C34.2162 125.167 34.3543 126.489 35.2547 127.219C36.1551 127.949 37.4768 127.811 38.2068 126.91L40.6908 123.847ZM34.5525 135.781C34.7653 134.641 34.014 133.545 32.8745 133.332C31.735 133.12 30.6388 133.871 30.4261 135.01C29.2814 141.142 29.7013 147.239 31.4916 152.718C31.8516 153.82 33.0367 154.421 34.1385 154.061C35.2404 153.701 35.8417 152.516 35.4816 151.414C33.9159 146.623 33.5335 141.24 34.5525 135.781ZM39.6257 160.27C38.8184 159.438 37.4897 159.418 36.6578 160.225C35.8259 161.032 35.8059 162.361 36.6131 163.193L40.0892 166.775C40.8964 167.607 42.2252 167.627 43.0571 166.82C43.889 166.013 43.909 164.684 43.1018 163.852L39.6257 160.27Z"
        fill="#5FCB88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.06623 138.152C5.76813 147.035 10.7861 155.343 18.084 162.112C40.0735 182.51 74.4351 181.22 94.8329 159.23L161.563 87.2934C181.961 65.304 180.67 30.9424 158.681 10.5446C153.808 6.02469 148.328 2.56968 142.527 0.168847C155.378 1.14043 168.001 6.30744 178.184 15.7529C202.085 37.9244 203.488 75.274 181.316 99.1756L105.308 181.115C83.1367 205.016 45.7871 206.419 21.8855 184.247C8.6076 171.93 2.27306 154.929 3.06623 138.152Z"
        fill="#629393"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.341 130.232L174.776 93.1092C193.598 72.8194 192.407 41.1138 172.117 22.2927C151.827 3.47151 120.122 4.66206 101.301 24.9518L66.8651 62.0744L140.341 130.232ZM181.316 99.1756C203.488 75.274 202.085 37.9244 178.184 15.7529C154.282 -6.41855 116.932 -5.01605 94.7609 18.8855L54.259 62.5478L140.814 142.838L181.316 99.1756Z"
        fill="#1D3934"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2927 106.891L60.7988 68.6141L54.259 62.5478L18.753 100.824C-3.41853 124.726 -2.01603 162.076 21.8855 184.247C45.7871 206.419 83.1367 205.016 105.308 181.115L140.814 142.838L134.275 136.771L98.7685 175.048C79.9473 195.338 48.2417 196.528 27.9519 177.707C7.66214 158.886 6.47158 127.181 25.2927 106.891Z"
        fill="#1D3934"
      />
    </g>
  </svg>
);

export const VVV_SVG = (
  <svg width="1em" height="1em" viewBox="-4 -4 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>VVV</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1896 21.4303C10.6663 21.0412 10.0346 20.7152 9.33619 20.5172C8.63774 20.3192 7.87245 20.2492 7.12414 20.3322C6.37582 20.4152 5.64449 20.6512 5.00641 20.9975C4.36834 21.3438 3.82352 21.8003 3.39818 22.2946C2.97167 22.7879 2.60009 23.3938 2.35122 24.0758C2.10235 24.7577 1.97618 25.5158 2.00391 26.2682C2.03162 27.0206 2.21323 27.7673 2.5116 28.4291C2.80998 29.091 3.22514 29.6679 3.6868 30.1285C4.14737 30.5901 4.72429 31.0053 5.38612 31.3037C6.04794 31.602 6.79468 31.7836 7.54706 31.8114C8.29945 31.8391 9.05751 31.7129 9.7395 31.464C10.4215 31.2152 11.0274 30.8436 11.5207 30.4171C12.015 29.9917 12.4715 29.4469 12.8178 28.8089C13.164 28.1708 13.4001 27.4394 13.4831 26.6911C13.5661 25.9428 13.4961 25.1775 13.298 24.4791C13.1 23.7806 12.7741 23.149 12.385 22.6257L13.6701 21.3406L14.6055 22.276H15.1368L15.778 21.6348V21.1035L14.8426 20.1681L16.2007 18.81L17.5587 20.1681L16.6233 21.1035V21.6348L17.2645 22.276H17.7958L18.7312 21.3406L20.0163 22.6257C19.6273 23.149 19.3013 23.7806 19.1033 24.4791C18.9053 25.1775 18.8352 25.9428 18.9182 26.6911C19.0012 27.4394 19.2373 28.1708 19.5836 28.8089C19.9298 29.4469 20.3863 29.9917 20.8806 30.4171C21.3739 30.8436 21.9798 31.2152 22.6618 31.464C23.3438 31.7129 24.1019 31.8391 24.8543 31.8114C25.6066 31.7836 26.3533 31.602 27.0152 31.3037C27.677 31.0053 28.2539 30.5901 28.7145 30.1285C29.1762 29.6679 29.5913 29.091 29.8897 28.4291C30.1881 27.7673 30.3697 27.0206 30.3974 26.2682C30.4251 25.5158 30.299 24.7577 30.0501 24.0758C29.8012 23.3938 29.4296 22.7879 29.0031 22.2946C28.5778 21.8003 28.033 21.3438 27.3949 20.9975C26.7568 20.6512 26.0255 20.4152 25.2772 20.3322C24.5289 20.2492 23.7636 20.3192 23.0651 20.5172C22.3667 20.7152 21.735 21.0412 21.2117 21.4303L19.9505 20.167L20.8854 19.2321V18.7008L20.2213 18.0367H19.69L18.7546 18.9722L17.3961 17.6146L24.5184 10.4923L27.4015 13.3754V10.3756H30.4013L27.5182 7.49247L30.4013 4.60935V4.07807L29.7372 3.41395H29.2059L16.2007 16.4192L3.1954 3.41395H2.66412L2 4.07807V4.60935L4.88312 7.49247L2 10.3756H4.99983V13.3754L7.88294 10.4923L15.0053 17.6146L13.6467 18.9722L12.7113 18.0367H12.18L11.5159 18.7008V19.2321L12.4508 20.167L11.1896 21.4303ZM22.7472 28.028C22.454 28.6296 22.5149 29.4632 22.8925 30.0157C23.2394 30.588 23.9732 30.9882 24.6422 30.97C25.3112 30.9882 26.045 30.588 26.3919 30.0157C26.7695 29.4632 26.8304 28.6296 26.5371 28.028L26.6102 27.9493C27.2117 28.2442 28.0466 28.1845 28.6 27.807C29.1732 27.4604 29.5743 26.7258 29.556 26.0561C29.5743 25.3865 29.1732 24.6519 28.6 24.3053C28.0466 23.9278 27.2117 23.8681 26.6102 24.1629L26.5371 24.0843C26.8304 23.4827 26.7695 22.6491 26.3919 22.0966C26.045 21.5243 25.3112 21.1241 24.6422 21.1423C23.9732 21.1241 23.2394 21.5243 22.8925 22.0966C22.5149 22.6491 22.454 23.4827 22.7472 24.0843L22.6742 24.1629C22.0727 23.8681 21.2378 23.9278 20.6844 24.3053C20.1112 24.6519 19.71 25.3865 19.7284 26.0561C19.71 26.7258 20.1112 27.4604 20.6844 27.807C21.2378 28.1845 22.0727 28.2442 22.6742 27.9493L22.7472 28.028ZM9.50855 30.0157C9.88615 29.4632 9.94706 28.6296 9.65379 28.028L9.72683 27.9493C10.3283 28.2442 11.1632 28.1845 11.7166 27.807C12.2899 27.4604 12.691 26.7258 12.6727 26.0561C12.691 25.3865 12.2899 24.6519 11.7166 24.3053C11.1632 23.9278 10.3283 23.8681 9.72683 24.1629L9.65379 24.0843C9.94706 23.4827 9.88615 22.6491 9.50855 22.0966C9.16163 21.5243 8.42783 21.1241 7.75883 21.1423C7.08985 21.1241 6.35604 21.5243 6.00912 22.0966C5.63152 22.6491 5.57061 23.4827 5.86389 24.0843L5.79084 24.1629C5.18933 23.8681 4.35448 23.9278 3.80105 24.3053C3.22781 24.6519 2.82669 25.3865 2.84501 26.0561C2.82669 26.7258 3.22781 27.4604 3.80105 27.807C4.35448 28.1845 5.18933 28.2442 5.79084 27.9493L5.86389 28.028C5.57061 28.6296 5.63152 29.4632 6.00912 30.0157C6.35604 30.588 7.08985 30.9882 7.75883 30.97C8.42783 30.9882 9.16163 30.588 9.50855 30.0157Z"
      fill="#DD3300"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1912 3.41394L19.6051 0L21.2957 1.69055V7.38911L16.6138 12.071H15.7685L11.0867 7.38911V1.69055L12.7772 0L16.1912 3.41394ZM12.7772 1.19541L15.7686 4.18673V9.68019L12.7772 6.68888V1.19541ZM16.614 4.18673L19.6053 1.19541V6.68888L16.614 9.68019V4.18673Z"
      fill="#DD3300"
    />
  </svg>
);

export const NEAR_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>NEAR</title>
    <circle cx="12" cy="12" r="12" fill="#00EC97" />
    <g clipPath="url(#near_clip0)">
      <path
        d="M15.9805 6.0878L13.2293 10.1707C13.1268 10.3024 13.1561 10.478 13.2878 10.5805C13.4049 10.6683 13.5659 10.6537 13.6683 10.5512L16.3756 8.19511C16.4195 8.15121 16.4927 8.15121 16.522 8.19511C16.5366 8.20975 16.5512 8.23902 16.5512 8.26829V15.6293C16.5512 15.6878 16.5073 15.7317 16.4342 15.7317C16.4049 15.7317 16.3756 15.7171 16.3463 15.6878L8.15123 5.88292C7.90245 5.60487 7.52196 5.41463 7.09757 5.41463H6.81952C6.04391 5.41463 5.41464 6.0439 5.41464 6.81951V17.1805C5.41464 17.9561 6.04391 18.5854 6.81952 18.5854C7.30245 18.5854 7.75611 18.3366 8.01952 17.9122L10.7707 13.8293C10.8732 13.6976 10.8439 13.5219 10.7122 13.4195C10.5951 13.3317 10.4342 13.3463 10.3317 13.4488L7.6244 15.7902C7.5805 15.8341 7.50733 15.8341 7.47806 15.7902C7.46342 15.7756 7.44879 15.7463 7.44879 15.7171V8.35609C7.44879 8.29755 7.49269 8.25365 7.56586 8.25365C7.59513 8.25365 7.6244 8.26829 7.65367 8.29755L15.8488 18.1024C16.1122 18.4244 16.5073 18.6 16.9171 18.6H17.2098C17.9854 18.6 18.6 17.9707 18.6 17.1951V6.81951C18.5854 6.0439 17.9561 5.41463 17.1805 5.41463C16.6976 5.41463 16.2439 5.66341 15.9805 6.0878Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="near_clip0">
        <rect width="13.1707" height="13.1707" fill="white" transform="translate(5.41464 5.41463)" />
      </clipPath>
    </defs>
  </svg>
);

export const UNI_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>UNI</title>
    <g clipPath="url(#uni_clip0)">
      <circle cx="12" cy="12" r="11.5" fill="url(#uni_paint0)" stroke="url(#uni_paint1)" />
      <g clipPath="url(#uni_clip1)">
        <path
          d="M16.3252 6.77314C16.3454 6.41965 16.3935 6.18648 16.4902 5.97355C16.5285 5.88926 16.5644 5.82028 16.5699 5.82028C16.5754 5.82028 16.5588 5.88249 16.5329 5.95852C16.4626 6.16517 16.4511 6.44782 16.4995 6.77668C16.561 7.19394 16.5959 7.25414 17.0385 7.70487C17.2461 7.91628 17.4876 8.18291 17.5751 8.29738L17.7343 8.50555L17.5751 8.35679C17.3805 8.17489 16.9329 7.8201 16.834 7.76939C16.7677 7.73538 16.7578 7.73597 16.7169 7.77653C16.6793 7.8139 16.6713 7.87006 16.6661 8.13556C16.6579 8.5493 16.6013 8.81491 16.4647 9.08046C16.3908 9.2241 16.3792 9.19344 16.4461 9.03131C16.496 8.91027 16.5011 8.85705 16.5007 8.4565C16.4999 7.65168 16.4041 7.4582 15.8417 7.12674C15.6993 7.04278 15.4645 6.92168 15.3201 6.85763C15.1757 6.79357 15.061 6.73778 15.0651 6.73362C15.0811 6.71782 15.6295 6.87732 15.8502 6.96192C16.1785 7.08778 16.2327 7.10408 16.2726 7.0889C16.2993 7.07873 16.3123 7.00116 16.3252 6.77314Z"
          fill="#FF007A"
        />
        <path
          d="M9.38816 5.60229C9.19337 5.57224 9.18514 5.56871 9.2768 5.5547C9.45248 5.52784 9.86723 5.56445 10.1531 5.63204C10.8203 5.78979 11.4274 6.1939 12.0755 6.91159L12.2477 7.10225L12.4941 7.06286C13.5317 6.89701 14.5874 7.02882 15.4703 7.43449C15.7132 7.5461 16.0962 7.76826 16.144 7.82535C16.1592 7.84354 16.1872 7.96067 16.2062 8.08565C16.2718 8.51802 16.2389 8.84941 16.106 9.09694C16.0336 9.23166 16.0296 9.27435 16.0782 9.38961C16.1171 9.48162 16.2253 9.5497 16.3325 9.54953C16.5519 9.54926 16.7881 9.19648 16.8975 8.70563L16.941 8.51066L17.0271 8.60768C17.4994 9.1399 17.8704 9.86571 17.9341 10.3823L17.9507 10.517L17.8713 10.3946C17.7347 10.1839 17.5974 10.0404 17.4216 9.92474C17.1047 9.71619 16.7696 9.6452 15.8823 9.59871C15.0808 9.55669 14.6272 9.4886 14.1775 9.34275C13.4122 9.09459 13.0265 8.76411 12.1175 7.57796C11.7137 7.05111 11.4642 6.75962 11.2159 6.52487C10.6519 5.99148 10.0976 5.71174 9.38816 5.60229Z"
          fill="#FF007A"
        />
        <path
          d="M9.7665 8.15367C9.3711 7.61223 9.12644 6.7821 9.17942 6.16155L9.19577 5.96951L9.2858 5.98585C9.45481 6.01651 9.74624 6.12439 9.88269 6.20683C10.2572 6.43303 10.4193 6.73084 10.5842 7.49558C10.6326 7.71957 10.6959 7.97305 10.7251 8.05887C10.7721 8.19701 10.9495 8.51965 11.0938 8.7292C11.1976 8.8801 11.1286 8.95161 10.899 8.93101C10.5482 8.89952 10.073 8.57336 9.7665 8.15367Z"
          fill="#FF007A"
        />
        <path
          d="M15.8452 12.1832C13.9973 11.4432 13.3465 10.8009 13.3465 9.71716C13.3465 9.55769 13.352 9.42719 13.3587 9.42719C13.3654 9.42719 13.437 9.47982 13.5176 9.54418C13.8923 9.84307 14.3119 9.97075 15.4735 10.1393C16.1571 10.2385 16.5417 10.3186 16.8966 10.4356C18.0245 10.8077 18.7222 11.5626 18.8887 12.5909C18.937 12.8897 18.9087 13.4501 18.8303 13.7454C18.7684 13.9786 18.5795 14.3991 18.5294 14.4152C18.5155 14.4197 18.5019 14.3667 18.4983 14.2947C18.4793 13.9086 18.2832 13.5327 17.9537 13.251C17.5791 12.9309 17.0758 12.676 15.8452 12.1832Z"
          fill="#FF007A"
        />
        <path
          d="M14.5479 12.4906C14.5247 12.3536 14.4846 12.1786 14.4587 12.1018L14.4115 11.962L14.4991 12.0598C14.6203 12.1951 14.7161 12.3682 14.7972 12.5988C14.8592 12.7748 14.8661 12.8271 14.8657 13.1131C14.8652 13.3939 14.8575 13.4527 14.8003 13.6112C14.7101 13.8609 14.5981 14.038 14.4103 14.2282C14.0727 14.5698 13.6388 14.759 13.0125 14.8375C12.9036 14.8511 12.5864 14.8741 12.3074 14.8885C11.6045 14.9249 11.1418 15 10.7261 15.1452C10.6663 15.1661 10.613 15.1788 10.6075 15.1734C10.5907 15.1567 10.8738 14.9889 11.1075 14.8769C11.4372 14.7189 11.7654 14.6328 12.5006 14.511C12.8638 14.4508 13.2389 14.3779 13.3341 14.3488C14.2336 14.0745 14.6959 13.3667 14.5479 12.4906Z"
          fill="#FF007A"
        />
        <path
          d="M15.395 13.9868C15.1495 13.4619 15.0931 12.9551 15.2276 12.4825C15.242 12.432 15.2651 12.3906 15.2791 12.3906C15.293 12.3906 15.3509 12.4218 15.4078 12.4599C15.5209 12.5356 15.7478 12.6632 16.3524 12.991C17.1067 13.4 17.5368 13.7168 17.8293 14.0786C18.0854 14.3956 18.2439 14.7565 18.3202 15.1967C18.3634 15.446 18.3381 16.0459 18.2738 16.297C18.071 17.0886 17.5996 17.7104 16.9273 18.0732C16.8288 18.1264 16.7403 18.17 16.7307 18.1702C16.7212 18.1704 16.7571 18.0796 16.8105 17.9685C17.0367 17.4983 17.0624 17.0409 16.8915 16.5317C16.7867 16.22 16.5733 15.8397 16.1422 15.1968C15.6411 14.4494 15.5183 14.2505 15.395 13.9868Z"
          fill="#FF007A"
        />
        <path
          d="M8.45421 16.8191C9.13995 16.2432 9.99315 15.8341 10.7704 15.7086C11.1053 15.6544 11.6633 15.6759 11.9734 15.7549C12.4706 15.8814 12.9154 16.1649 13.1466 16.5025C13.3727 16.8326 13.4697 17.1202 13.5706 17.7601C13.6105 18.0125 13.6538 18.266 13.6669 18.3234C13.7427 18.655 13.8902 18.9201 14.0731 19.0533C14.3635 19.2647 14.8636 19.2778 15.3555 19.087C15.439 19.0545 15.5115 19.0322 15.5166 19.0372C15.5345 19.0548 15.2868 19.2198 15.112 19.3066C14.8769 19.4234 14.6899 19.4686 14.4414 19.4686C13.9909 19.4686 13.6168 19.2406 13.3047 18.7758C13.2432 18.6843 13.1052 18.4103 12.9979 18.1669C12.6683 17.4193 12.5056 17.1916 12.1229 16.9423C11.7899 16.7255 11.3605 16.6866 11.0374 16.8442C10.613 17.0511 10.4946 17.5905 10.7986 17.9323C10.9193 18.0682 11.1446 18.1854 11.3288 18.2082C11.6735 18.2508 11.9696 17.9901 11.9696 17.644C11.9696 17.4193 11.8828 17.2911 11.6642 17.1929C11.3657 17.0589 11.0447 17.2156 11.0463 17.4945C11.0469 17.6135 11.099 17.6882 11.2189 17.7421C11.2958 17.7767 11.2976 17.7795 11.2349 17.7665C10.9609 17.71 10.8967 17.3816 11.117 17.1635C11.3814 16.9018 11.9283 17.0173 12.116 17.3746C12.1949 17.5247 12.2041 17.8236 12.1353 18.004C11.9814 18.408 11.5326 18.6205 11.0773 18.5049C10.7673 18.4262 10.6411 18.3409 10.2673 17.958C9.61787 17.2927 9.36574 17.1638 8.42947 17.0184L8.25006 16.9905L8.45421 16.8191Z"
          fill="#FF007A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.40696 4.91054C7.57578 7.52859 9.06957 8.60876 9.23557 8.83697C9.37261 9.02541 9.32105 9.1948 9.08623 9.32758C8.95565 9.40137 8.68721 9.47617 8.5528 9.47617C8.40077 9.47617 8.34858 9.41786 8.34858 9.41786C8.26043 9.3347 8.21078 9.34925 7.75813 8.55011C7.12969 7.58026 6.60377 6.77572 6.58943 6.76225C6.55625 6.7311 6.55682 6.73215 7.69405 8.75592C7.87779 9.17772 7.7306 9.33256 7.7306 9.39263C7.7306 9.51484 7.69707 9.57909 7.5455 9.74724C7.29281 10.0276 7.17985 10.3426 7.0983 10.9946C7.00689 11.7255 6.74985 12.2418 6.0375 13.1253C5.62051 13.6426 5.55228 13.7374 5.44706 13.9459C5.31453 14.2084 5.27809 14.3554 5.26332 14.6869C5.24771 15.0374 5.27812 15.2639 5.38578 15.599C5.48004 15.8924 5.57843 16.0861 5.82995 16.4736C6.04702 16.8079 6.17201 17.0564 6.17201 17.1536C6.17201 17.231 6.18685 17.2311 6.52321 17.1555C7.32816 16.9747 7.98178 16.6568 8.34938 16.2671C8.57689 16.0259 8.63029 15.8927 8.63205 15.5622C8.63319 15.346 8.62552 15.3008 8.56676 15.1764C8.47113 14.974 8.29701 14.8057 7.91325 14.5448C7.41042 14.2029 7.19566 13.9277 7.13633 13.5492C7.08767 13.2386 7.14412 13.0194 7.42229 12.4396C7.71021 11.8394 7.78156 11.5836 7.82983 10.9787C7.861 10.5878 7.90417 10.4337 8.01708 10.3099C8.13484 10.1809 8.24085 10.1372 8.53228 10.0976C9.00739 10.0331 9.30995 9.91079 9.55863 9.68288C9.77436 9.48519 9.86464 9.29465 9.8785 9.00785L9.88901 8.79049L9.76845 8.65068C9.33186 8.14442 5.11459 4.51256 5.08772 4.51256C5.08198 4.51256 5.22565 4.69166 5.40696 4.91054ZM6.41708 15.0835C6.51579 14.9097 6.46334 14.6861 6.29823 14.577C6.14222 14.4738 5.89987 14.5224 5.89987 14.6568C5.89987 14.6978 5.92268 14.7277 5.97409 14.754C6.06065 14.7983 6.06694 14.8481 5.99883 14.95C5.92985 15.0531 5.93542 15.1437 6.01454 15.2053C6.14204 15.3046 6.32255 15.25 6.41708 15.0835Z"
          fill="#FF007A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1888 10.2117C9.9658 10.2798 9.74895 10.5149 9.68184 10.7614C9.64091 10.9118 9.66414 11.1757 9.72545 11.2571C9.82454 11.3887 9.92035 11.4234 10.1798 11.4216C10.6878 11.418 11.1293 11.2014 11.1807 10.9305C11.2228 10.7085 11.0288 10.4008 10.7617 10.2657C10.6238 10.196 10.3307 10.1683 10.1888 10.2117ZM10.7826 10.6735C10.861 10.5628 10.8267 10.4431 10.6935 10.3622C10.4398 10.2081 10.0561 10.3356 10.0561 10.574C10.0561 10.6927 10.2562 10.8221 10.4396 10.8221C10.5617 10.8221 10.7287 10.7497 10.7826 10.6735Z"
          fill="#FF007A"
        />
      </g>
    </g>
    <defs>
      <linearGradient id="uni_paint0" x1="22.125" y1="18" x2="3" y2="2.625" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEE8F2" />
        <stop offset="1" stopColor="#FDE9F2" />
      </linearGradient>
      <linearGradient id="uni_paint1" x1="3.34211" y1="4.61713e-07" x2="20.6579" y2="24" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FBEDF4" />
        <stop offset="0.853652" stopColor="#FDB9D8" />
      </linearGradient>
      <clipPath id="uni_clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="uni_clip1">
        <rect width="13.8249" height="15" fill="white" transform="translate(5.08755 4.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ARB_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>ARB</title>
    <rect width="24" height="24" rx="12" fill="#2C374B" />
    <path
      d="M13.9281 11.3301L15.1025 9.33593L18.2699 14.2683L18.271 15.2146L18.2607 8.70086C18.2528 8.54124 18.1684 8.3953 18.0338 8.30978L12.3319 5.03067C12.1939 4.96454 12.0332 4.96568 11.8963 5.03295C11.8792 5.04208 11.8621 5.0512 11.845 5.0626L11.8257 5.07514L6.2913 8.28242L6.26964 8.29154C6.24114 8.30522 6.21377 8.32119 6.18755 8.33943C6.08379 8.41354 6.0131 8.52527 5.9903 8.65069C5.98688 8.67007 5.9846 8.68946 5.98346 8.7077L5.99258 14.0163L8.94218 9.44425C9.31388 8.83768 10.1223 8.64271 10.8736 8.65297L11.755 8.67578L6.56038 17.0058L7.17265 17.3581L12.4299 8.68376L14.7536 8.67578L9.50999 17.5691L11.6957 18.8267L11.9568 18.9772C12.0697 19.0216 12.1939 19.0239 12.3091 18.984L18.0909 15.6331L16.9849 16.2738L13.9281 11.3301ZM14.3762 17.7857L12.1688 14.3219L13.5154 12.0358L16.4137 16.6045L14.3762 17.7857Z"
      fill="#2D374B"
    />
    <path d="M12.1682 14.3218L14.3756 17.7856L16.4142 16.6044L13.5159 12.0369L12.1682 14.3218Z" fill="#28A0F0" />
    <path
      d="M18.2705 15.2146L18.2694 14.2682L15.102 9.33588L13.9265 11.3289L16.9833 16.2738L18.0892 15.633C18.1975 15.5452 18.2637 15.4152 18.2705 15.2761V15.2146Z"
      fill="#28A0F0"
    />
    <path
      d="M5 16.1074L6.56088 17.007L11.7555 8.67696L10.8741 8.65416C10.1228 8.6439 9.31438 8.83887 8.94268 9.44543L5.99308 14.0175L5.00114 15.5419L5 16.1074Z"
      fill="white"
    />
    <path d="M14.7528 8.67686L12.4292 8.68485L7.17188 17.3592L9.00982 18.4173L9.50921 17.5701L14.7528 8.67686Z" fill="white" />
    <path
      d="M19.2498 8.66435C19.2281 8.1775 18.9681 7.73283 18.5554 7.47516L12.7793 4.15386C12.3609 3.94863 11.8718 3.94863 11.4545 4.15386C11.4066 4.1778 5.83688 7.40789 5.83688 7.40789C5.75935 7.44551 5.68524 7.48884 5.61569 7.53901C5.24969 7.8001 5.0228 8.21398 5 8.66207V15.5418L5.99194 14.0174L5.98396 8.70995C5.99308 8.56287 6.06833 8.42719 6.18805 8.34054C6.21427 8.32116 11.8786 5.04319 11.8968 5.03407C12.0337 4.9668 12.1944 4.9668 12.3324 5.03179L18.0343 8.31204C18.1689 8.39755 18.2533 8.54349 18.2612 8.70311V15.2784C18.259 15.4164 18.1962 15.5464 18.0914 15.6353L16.9854 16.2761L16.4153 16.6067L14.3767 17.7879L12.3096 18.9862C12.1956 19.0261 12.0702 19.0239 11.9573 18.9794L9.51163 17.5724L9.01223 18.4196L11.2105 19.6852C11.2834 19.7262 11.3484 19.7627 11.4009 19.7935C11.483 19.8391 11.5388 19.871 11.5594 19.8801C11.7429 19.9611 11.9425 20.0021 12.1431 19.9998C12.3278 19.9998 12.5103 19.9656 12.6813 19.8984L18.6865 16.4209C19.0297 16.1541 19.2361 15.7493 19.252 15.3149L19.2498 8.66435Z"
      fill="#96BEDC"
    />
  </svg>
);

export const AAVE_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>AAVE</title>
    <g clipPath="url(#aave_clip0)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24Z"
        fill="#9391F7"
      />
      <path
        d="M9.76915 12.5853C10.7981 12.4182 11.4969 11.4485 11.3299 10.4196C11.1628 9.39058 10.1932 8.6918 9.16427 8.85884C8.13522 9.02588 7.43645 9.99546 7.60348 11.0245C7.77052 12.0535 8.74011 12.7522 9.76915 12.5853ZM14.7027 12.5853C15.7316 12.4182 16.4304 11.4485 16.2633 10.4196C16.0963 9.39058 15.1267 8.6918 14.0977 8.85884C13.0687 9.02588 12.37 9.99546 12.537 11.0245C12.704 12.0535 13.6736 12.7522 14.7027 12.5853Z"
        fill="white"
      />
      <path
        d="M11.9303 2.93024C6.80508 2.93024 2.64989 7.16461 2.65121 12.3864H5.02167C5.02167 8.47309 8.09029 5.30033 11.9303 5.30033C15.7703 5.30033 18.8389 8.47309 18.8389 12.3864H21.2094C21.2102 7.16461 17.055 2.93024 11.9303 2.93024Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="aave_clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MORPHO_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>MORPHO</title>
    <g clipPath="url(#morpho_clip0)">
      <mask id="morpho_mask0" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#morpho_mask0)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#2470FF"
        />
        <path
          opacity="0.8"
          d="M6.9946 14.1839V17.7579C6.9946 17.978 7.1808 18.0693 7.23873 18.09C7.29665 18.115 7.49113 18.1689 7.66492 18.007L10.3687 15.4087C10.5989 15.1874 10.8211 14.9549 10.9882 14.6828C11.0667 14.5549 11.0993 14.4828 11.0993 14.4828C11.2649 14.1466 11.2649 13.8228 11.1035 13.499C10.8635 13.0174 10.2511 12.5276 9.32833 12.0627L7.75181 12.9427C7.28425 13.2084 6.9946 13.6775 6.9946 14.1839Z"
          fill="white"
        />
        <path
          d="M5.44 6.23462V9.98305C5.44 10.4521 5.75448 10.8672 6.20138 11C7.72409 11.44 10.3764 12.3865 11.0178 13.777C11.1005 13.9597 11.1502 14.1382 11.1668 14.325C11.593 13.5487 11.7874 12.6562 11.6965 11.7514C11.5722 10.4686 10.8936 9.30225 9.8344 8.55921L6.05655 5.91499C5.99033 5.86517 5.91171 5.84027 5.8331 5.84027C5.76689 5.84027 5.70896 5.85273 5.6469 5.88593C5.52275 5.9565 5.44 6.08518 5.44 6.23462Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M17.0509 14.1839V17.7579C17.0509 17.978 16.8647 18.0693 16.8067 18.09C16.7489 18.115 16.5542 18.1689 16.3806 18.007L13.6138 15.3483C13.4255 15.1673 13.2457 14.9758 13.1038 14.7565C12.9914 14.5828 12.9462 14.4828 12.9462 14.4828C12.7806 14.1466 12.7806 13.8228 12.9419 13.499C13.182 13.0174 13.7944 12.5276 14.717 12.0627L16.2936 12.9427C16.7654 13.2084 17.0509 13.6775 17.0509 14.1839Z"
          fill="white"
        />
        <path
          d="M18.608 6.23435V9.98272C18.608 10.4518 18.2934 10.8669 17.8466 10.9998C16.3238 11.4398 13.6716 12.3862 13.0302 13.7768C12.9474 13.9594 12.8977 14.1379 12.8812 14.3247C12.455 13.5485 12.2606 12.656 12.3515 11.7511C12.4756 10.4684 13.1542 9.302 14.2136 8.55896L17.9914 5.91472C18.0577 5.8649 18.1362 5.84 18.2149 5.84C18.281 5.84 18.339 5.85245 18.401 5.88566C18.5252 5.95623 18.608 6.08491 18.608 6.23435Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="morpho_clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ENA_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none">
    <title>ENA</title>
    <g clipPath="url(#ena_clip0)">
      <mask id="ena_mask0" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <path
          d="M23.9883 11.9942C23.9883 5.36997 18.6183 0 11.9942 0C5.36997 0 0 5.36997 0 11.9942C0 18.6183 5.36997 23.9883 11.9942 23.9883C18.6183 23.9883 23.9883 18.6183 23.9883 11.9942Z"
          fill="white"
        />
      </mask>
      <g mask="url(#ena_mask0)">
        <path
          d="M23.9883 11.9942C23.9883 5.36997 18.6183 0 11.9942 0C5.36997 0 0 5.36997 0 11.9942C0 18.6183 5.36997 23.9883 11.9942 23.9883C18.6183 23.9883 23.9883 18.6183 23.9883 11.9942Z"
          fill="url(#ena_paint0)"
        />
        <mask id="ena_mask1" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M23.9883 0H0V23.9883H23.9883V0Z" fill="white" />
        </mask>
        <g mask="url(#ena_mask1)">
          <path
            d="M17.2942 6.76701V10.3815H16.1169V7.94541H10.8956L14.3911 11.9908L10.8956 16.0363H16.1169V13.6002H17.2942V17.2147H9.33625L4.89304 11.9908L9.33625 6.76701H17.2942ZM6.43927 11.9908L9.6117 15.7204L12.8344 11.9908L9.6117 8.26104L6.43927 11.9908Z"
            fill="white"
          />
          <path
            d="M11.9885 0.234146H11.9884C5.49672 0.234146 0.234146 5.49672 0.234146 11.9884C0.234146 18.4801 5.49672 23.7427 11.9884 23.7427H11.9885C18.4803 23.7427 23.7428 18.4801 23.7428 11.9884C23.7428 5.49672 18.4803 0.234146 11.9885 0.234146Z"
            stroke="url(#ena_paint1)"
            strokeWidth="0.479766"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient id="ena_paint0" x1="11.9942" y1="-4.63962" x2="11.9942" y2="29.3227" gradientUnits="userSpaceOnUse">
        <stop stopColor="#040404" />
        <stop offset="1" stopColor="#3D475A" />
      </linearGradient>
      <radialGradient
        id="ena_paint1"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-17.7953 17.7953 -17.7952 -17.7954 21.0545 2.81841)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.496044" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <clipPath id="ena_clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
